var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live"},[_c('div',{staticClass:"live-menu"},[_c('div',{staticClass:"logo"},[_vm._v(" 小艺帮直播监考 ")]),_c('div',{staticClass:"content custom-scrollbar"},[_c('AuditTab')],1),_c('div',{staticClass:"logout",on:{"click":_vm.onLogout}},[_vm._v(" 退出 ")])]),_c('div',{staticClass:"live-container"},[_c('AuditView')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }